import axios, { type AxiosError } from 'axios'

export interface ValidationError {
  message: string
  errors: Record<string, string[]>
}

export const isErrorAxios = (error: unknown): error is AxiosError<ValidationError, Record<string, unknown>> => {
  return axios.isAxiosError<ValidationError, Record<string, unknown>>(error)
}

export interface ErrorResponse {
  response: {
    status?: number
    data: {
      message?: string
      success?: boolean
      statusCode: number
      errorCode?: string
      data?: unknown
    }
  }
  message?: string
  errors?: Record<string, string[]>
}
